/* ABC: свой выпадающий список размеров вместо системного.
   Владелец: на телефоне системный список выглядит чужеродно, хочется
   одинаково на ПК и телефоне. Настоящий <select> остаётся (его читает
   тема и форма «в корзину»), но скрыт; поверх — наша кнопка и список.
   Выбор = выставить значение в <select> и отправить change, как будто
   человек выбрал сам — тема перерисует цену, наличие и кнопку. */
(function () {
  var SOLD = /\s*-\s*(unavailable|sold out)\s*$/i;
  /* Размер считается выбранным, только если человек выбрал его сам
     (или пришёл по ссылке с ?variant=). Иначе на кнопке «SELECT SIZE»,
     а «ADD TO CART» сначала открывает список размеров. */
  var picked = /[?&]variant=/.test(location.search);

  function label(opt) {
    var t = (opt.textContent || '').trim();
    return { text: t.replace(SOLD, ''), sold: SOLD.test(t) || opt.disabled };
  }

  function closeAll(except) {
    document.querySelectorAll('.abc-ss.is-open').forEach(function (w) {
      if (w === except) return;
      w.classList.remove('is-open');
      var b = w.querySelector('.abc-ss__btn');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  function sig(select) {
    return select.selectedIndex + '|' + Array.prototype.map.call(select.options, function (o) { return o.value + o.textContent.trim(); }).join(',');
  }

  function render(wrap, select) {
    var s = sig(select) + (picked ? '|p' : '');
    if (wrap.dataset.abcSig === s) return;   // без изменений — не трогаем DOM (иначе наблюдатель зациклится)
    wrap.dataset.abcSig = s;
    var btn = wrap.querySelector('.abc-ss__btn');
    var list = wrap.querySelector('.abc-ss__list');
    var cur = select.options[select.selectedIndex];
    var c = cur ? label(cur) : { text: '', sold: false };
    var single = select.options.length < 2;
    /* ABC 01.10: у GIFT CARD — «SELECT AMOUNT» (snippets/variant-main-picker.liquid: data-abc-pick-label) */
    btn.querySelector('.abc-ss__value').textContent = (picked || single) ? c.text : (wrap.dataset.abcPickLabel || 'Select size');
    wrap.classList.toggle('is-unpicked', !(picked || single));
    list.innerHTML = '';
    Array.prototype.forEach.call(select.options, function (opt, i) {
      var l = label(opt);
      var li = document.createElement('li');
      var sel = picked && i === select.selectedIndex;
      li.className = 'abc-ss__opt' + (l.sold ? ' is-sold' : '') + (sel ? ' is-selected' : '');
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', sel ? 'true' : 'false');
      li.dataset.value = opt.value;
      li.innerHTML = '<span class="abc-ss__opt-text"></span>' + (l.sold ? '<span class="abc-ss__opt-note">Notify me</span>' : '');
      li.firstChild.textContent = l.text;
      list.appendChild(li);
    });
  }

  /* ABC 01.10: GIFT CARD — цена под списком меняется сразу. Тема берёт новую цену из ответа сервера
     (вся страница товара заново), на живом он шёл до ~15 с — после выбора 250 ещё долго стояла цена 50.
     У номиналов карты сумма уже есть в <option data-abc-price> — ставим её сразу; ответ сервера потом
     перерисует цену тем же значением. «В корзину» тема и так ждёт этот ответ (добавится выбранный номинал). */
  function showPrice(select) {
    var o = select.options[select.selectedIndex];
    var price = o && o.dataset.abcPrice;
    if (!price) return;
    var picker = select.closest('variant-picker');
    var pid = picker && picker.dataset.productId;
    var scope = select.closest('.product-details, dialog, .shopify-section') || document;
    scope.querySelectorAll('product-price').forEach(function (pp) {
      if (pid && pp.dataset.productId && pp.dataset.productId !== pid) return;
      var el = pp.querySelector('[ref="priceContainer"] .price');
      if (el && el.textContent.trim() !== price) el.textContent = price;
    });
  }

  function enhance(select) {
    var wrap = select.parentElement;
    if (!wrap) return;
    if (wrap.querySelector(':scope > .abc-ss__btn')) { render(wrap, select); return; }
    wrap.classList.add('abc-ss');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'abc-ss__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="abc-ss__value"></span><span class="abc-ss__caret" aria-hidden="true"></span>';
    var list = document.createElement('ul');
    list.className = 'abc-ss__list';
    list.setAttribute('role', 'listbox');
    wrap.appendChild(btn);
    wrap.appendChild(list);
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    delete wrap.dataset.abcSig;
    render(wrap, select);
  }

  /* 25.09: выбран размер, которого нет в наличии — кнопка «в корзину» становится
     NOTIFY ME и открывает подписку на поступление (вместо серого SOLD OUT) */
  function soldPicked() {
    if (!picked) return null;
    var select = document.querySelector('.product-details select.variant-option__select, select.variant-option__select');
    if (!select) return null;
    var cur = select.options[select.selectedIndex];
    return cur && label(cur).sold ? label(cur).text : null;
  }
  function syncNotify() {
    var size = soldPicked();
    document.querySelectorAll('.product-details .add-to-cart-button:not(.sticky-add-to-cart__button)').forEach(function (b) {
      if (size) {
        b.classList.add('abc-atc--notify');
        b.dataset.abcNotifySize = size;
        if (b.disabled) b.disabled = false;
      } else if (b.classList.contains('abc-atc--notify')) {
        b.classList.remove('abc-atc--notify');
        delete b.dataset.abcNotifySize;
      }
    });
  }
  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.abc-atc--notify');
    if (!b || !window.abcSheet) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var h1 = document.querySelector('.product-details h1, .product-details .product-title, .product-details [class*="title"]');
    var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
    window.abcSheet.open({
      title: 'Notify me',
      body: window.abcSheet.notifyForm({ title: h1 ? h1.textContent.trim() : '', handle: handle }, b.dataset.abcNotifySize)
    });
  }, true);

  function scan() {
    document.querySelectorAll('select.variant-option__select').forEach(enhance);
    syncNotify();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.abc-ss__btn');
    if (btn) {
      var w = btn.parentElement;
      var open = !w.classList.contains('is-open');
      closeAll(w);
      w.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    var opt = e.target.closest && e.target.closest('.abc-ss__opt');
    if (opt) {
      var wrap = opt.closest('.abc-ss');
      var select = wrap.querySelector('select');
      closeAll();
      /* нет в наличии — не выбираем, а предлагаем подписаться на поступление */
      if (opt.classList.contains('is-sold') && window.abcSheet) {
        var h1 = document.querySelector('.product-details h1, .product-details .product-title, .product-details [class*="title"]');
        var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
        window.abcSheet.open({
          title: 'Notify me',
          body: window.abcSheet.notifyForm({ title: h1 ? h1.textContent.trim() : '', handle: handle }, opt.dataset.value)
        });
        return;
      }
      picked = true;
      if (select && select.value !== opt.dataset.value) {
        select.value = opt.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        showPrice(select);
      }
      render(wrap, select);
      return;
    }
    closeAll();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* «ADD TO CART» без выбранного размера — открываем список размеров */
  function needsPick(target) {
    if (picked) return null;
    var btn = target.closest && target.closest('.add-to-cart-button, [name="add"], button[type="submit"]');
    if (!btn || !(btn.classList.contains('add-to-cart-button') || btn.closest('form[action*="/cart/add"]'))) return null;
    var scope = btn.closest('.product-details, product-form-component, .product-information') || document;
    var wrap = scope.querySelector('.abc-ss.is-unpicked');
    return wrap;
  }
  function openPick(wrap) {
    closeAll(wrap);
    wrap.classList.add('is-open');
    var b = wrap.querySelector('.abc-ss__btn');
    if (b) b.setAttribute('aria-expanded', 'true');
    var r = wrap.getBoundingClientRect();
    if (r.top < 60 || r.bottom > innerHeight - 120) window.scrollBy({ top: r.top - innerHeight / 3, behavior: 'smooth' });
  }
  /* window, а не document: тема ловит нажатие и отправку формы своим
     обработчиком на document, и он срабатывал раньше нашего — товар
     добавлялся в корзину без выбранного размера */
  window.addEventListener('click', function (e) {
    var wrap = needsPick(e.target);
    if (!wrap) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openPick(wrap);
  }, true);
  window.addEventListener('submit', function (e) {
    if (picked) return;
    var wrap = e.target.closest && (e.target.closest('.product-details') || document).querySelector('.abc-ss.is-unpicked');
    if (!wrap || !e.target.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openPick(wrap);
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('select.variant-option__select')) { render(e.target.parentElement, e.target); syncNotify(); }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  /* тема перерисовывает блок вариантов после выбора — достраиваем заново */
  /* 25.09: достраиваем сразу в наблюдателе (он срабатывает до отрисовки кадра),
     а не через setTimeout — иначе на кадр был виден «голый» список темы и блок
     выбора размера мерцал при смене размера (владелец) */
  var busy = false;
  new MutationObserver(function () {
    if (busy) return;
    busy = true;
    try { scan(); } finally { busy = false; }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
